import { rootApi } from "../../api/rootApi";

export const skuProductMap = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchCenturySkuProductMap: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/century/sku`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
        fetchCenturySkuCsvProductMap: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/century/sku/csv`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
        fetchCenturySkuProductMapCount: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/century/sku/count`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),

        fetchCenturyCategory: builder.mutation({
            query: (params) => {
                return {
                    method: "GET",
                    url: `/tenant/heirarchy/master`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    }
                };
            },
        }),

        fetchCenturySubCategory: builder.mutation({
            query: (params) => {
                return {
                    method: "GET",
                    url: `/tenant/heirarchy/sub` + "/" + params.id,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    }
                };
            },
        }),

        fetchCenturyProduct: builder.mutation({
            query: (params) => {
                return {
                    method: "GET",
                    url: `app/product` + "/" + params.id,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    }
                };
            },
        }),

        createSkuProductMap: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `tenant/century/sku/add`,
                    body: params.body,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    }
                };
            },
        }),

        bulkUploadSkuProductMap: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `tenant/century/sku/bulkAdd`,
                    body: params.body,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    }
                };
            },
        }),

        addCenturySubCategory: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/heirarchy/add`,
                    body: params.body,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    }
                };
            },
        }),

        addCenturyProduct: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/products/add`,
                    body: params.body,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    }
                };
            },
        })
    }),
});

export const {
    useFetchCenturySkuProductMapMutation,
    useFetchCenturySkuProductMapCountMutation,
    useFetchCenturyCategoryMutation,
    useFetchCenturySubCategoryMutation,
    useFetchCenturyProductMutation,
    useCreateSkuProductMapMutation,
    useFetchCenturySkuCsvProductMapMutation,
    useBulkUploadSkuProductMapMutation,
    useAddCenturySubCategoryMutation,
    useAddCenturyProductMutation
} = skuProductMap;
